__turbopack_context__.v({
  "blok-big-title": "yarn-dropdown-module__fzYU4W__blok-big-title",
  "blok-subtitle": "yarn-dropdown-module__fzYU4W__blok-subtitle",
  "blok-title": "yarn-dropdown-module__fzYU4W__blok-title",
  "content": "yarn-dropdown-module__fzYU4W__content",
  "dropdown": "yarn-dropdown-module__fzYU4W__dropdown",
  "section-label": "yarn-dropdown-module__fzYU4W__section-label",
});
